import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-whitelist-outlets',
  templateUrl: './whitelist-outlets.component.html',
  styleUrls: ['./whitelist-outlets.component.scss']
})
export class WhitelistOutletsComponent implements OnInit {
  flag = true;
  @Output() whiteListData: EventEmitter<boolean> = new EventEmitter();
  @Input() caplimt: any;
  @Input() cartonid = "";
  whiteListUser: any = []
  page = 1;
  getPaginationCount;

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  cartonLocalFlags : any = {};

  constructor(
    private ngWizardService: NgWizardService,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration

  ) {
  }

  ngOnInit() {
    this.cartonLocalFlags = JSON.parse(localStorage.getItem('cartonFlgs'))
    console.log("@#$%^&*(*&^%$#@#$%^&*&^%$##$%^&*",this.cartonLocalFlags)
    console.log("cap", this.caplimt)
    this.getWhiteListUser();

  }
  submit() {
    this.whiteListData.emit(this.flag);
  }

  uploadExcel(id) {
    this.router.navigate(["/hubAdmin/carton-upload/" + id + "/" + this.caplimt + "/" + this.cartonid])
  }

  getWhiteListUser() {
    this.apiService.getHeaders(this.apiConfig.CartonWhiteList + `?campaign_id=${this.cartonid}&page=${this.page}`).subscribe((res: any) => {
      console.log(res)
      this.whiteListUser = res.body.data.pagination_data;
      debugger
      if(this.whiteListUser.length == 0){
        this.whiteListData.emit(false);

      }
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')

      //2) for excelData
      this.excelData = res.body.data.excel_download_data;
      for (var k in this.excelData[0]) {
        if (typeof this.excelData[k] !== 'function') {
          console.log("Key is " + k.replace(/_/g, ' '));
          this.excelFormat.header = k.replace(/_/g, ' ');
          this.excelFormat.key = k
          this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
          console.log(this.excelArray)
        }
      }
    })
  }
  DownloadReportExcel() {
    console.log("here",this.excelData, this.excelArray)
    this.exportExcelService.DownloadReportExcel('Whitelist_outlet', this.excelData, this.excelArray);
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getWhiteListUser();
  }
}
